import { useRef } from 'react';

// Dev-only render tracker hook. No-op in production.
/**
 * Hook to track the number of renders of a component during development.
 * @param {string} name - Name of the component to track
 * @returns {number} The current render count for the component
 */
export default function useRenderTracker(name) {
  const renders = useRef(0);
  renders.current += 1;
  if (process.env.NODE_ENV === 'development') {
    if (!window.__renderTracker) {
      const map = new Map();
      window.__renderTracker = {
        _map: map,
        incr: (key) => map.set(key, (map.get(key) || 0) + 1),
        getAll: () => Array.from(map.entries()).map(([k, v]) => ({ component: k, count: v })),
        dump: () => {
          const results = Array.from(map.entries())
            .map(([k, v]) => ({ component: k, count: v }))
            .sort((a, b) => b.count - a.count);
          console.table(results.slice(0, 200));
          return results;
        },
        reset: () => map.clear(),
      };
    }
    // record this render
    window.__renderTracker.incr(name);
  }

  return renders.current;
}
